import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
export function LetterOpening() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      salutation: 'Dear job seeker,',
      p1: "If you've been applying to jobs and hearing nothing back, there's a strong chance your application is getting stopped before it ever reaches a recruiter.",
      p2: "Not because you're not qualified—",
      p3: "but because your resume isn't being read the way employers' systems expect.",
      p4: "Most companies use Applicant Tracking Systems (ATS) to parse resumes, identify relevant skills, and filter candidates at scale. If your resume is missing the right keywords or the structure is hard to scan, you can be ranked as 'not a match' automatically.",
      closing: 'CV Go App is built to fix that—fast, professionally, and without guesswork.'
    },
    es: {
      salutation: 'Estimado/a postulante,',
      p1: 'Si has estado postulando a trabajos y no recibes respuestas, es muy posible que tu candidatura se esté quedando en el camino antes de que un reclutador la vea.',
      p2: 'No necesariamente porque no tengas potencial,',
      p3: 'sino porque tu CV no está siendo leído de la forma en que los sistemas de selección esperan.',
      p4: "Muchas empresas usan ATS (Applicant Tracking Systems) para analizar CVs, identificar habilidades y filtrar candidatos a gran escala. Si tu CV no incluye palabras clave relevantes o si su estructura es difícil de interpretar, el sistema puede clasificarte como 'no apto' automáticamente.",
      closing: 'CV Go App existe para corregir eso—rápido, con calidad profesional y sin adivinar.'
    }
  };
  const t = content[language];
  return <section className="py-20 bg-white" data-id="element-79">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg prose-blue mx-auto font-serif text-gray-700 leading-relaxed" data-id="element-81">
          <p className="font-bold text-gray-900 text-xl mb-8" data-id="element-82">{t.salutation}</p>

          <p className="mb-6" data-id="element-83">{t.p1}</p>

          <div className="pl-6 border-l-4 border-blue-200 my-8 italic text-gray-600" data-id="element-84">
            <p className="mb-2" data-id="element-85">{t.p2}</p>
            <p className="font-medium text-gray-900" data-id="element-86">{t.p3}</p>
          </div>

          <p className="mb-8" data-id="element-87">{t.p4}</p>

          <p className="text-xl font-medium text-blue-700 text-center mt-12" data-id="element-88">
            {t.closing}
          </p>
        </motion.div>
      </div>
    </section>;
}